(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.factory('SubmitFactory', submit);

	submit.$inject = ['$http', '$q', '$rootScope', 'DataFactory', 'ErrorFactory', 'SessionFactory'];

	function submit($http, $q, $rootScope, DataFactory, ErrorFactory, SessionFactory) {

		var service = {
			submit: submitApp,
		}

		return service;

		function submitApp(sessionId) {
			var deferred = $q.defer();
			$http({
				method: 'POST',
				url: baseUrl + 'api/submit/post',
				data: JSON.stringify({
					'session_id': sessionId,
				})
			}).then(function (response) {
				var data;
				try { data = JSON.parse(response.data); }
				catch (e) { data = response.data };
				if (data['result_code'] === "0") {
					DataFactory.appData.applicant.submit = response.data['result_content'];

					//if (data["result_content"].QFreeze) $rootScope.gaCustEvent.tuEndresultSuccess();
					//else $rootScope.gaCustEvent.tuEndresultFailure();

					if (data["result_content"].prequalResult === "Success") {
						$rootScope.ga.submitSuccess();
					} else {
						$rootScope.ga.errors.submitError();
					}
					
					if (data["result_content"].prequalResult === "Success" && !data["result_content"].QFreeze) {
						$rootScope.gaCustEvent.tuEndresultSuccess();
					} else if (data["result_content"].prequalResult === "Success" && data["result_content"].QFreeze) {
						$rootScope.gaCustEvent.tuEndresultFreezeSuccess();// qfreeze
					}
					
					deferred.resolve(data);
					SessionFactory.deleteCurrentSession();
				}
				else {
					var errCode = data['result_code'].split("-")[0];
					if (errCode === "TU") $rootScope.ga.errors.tuError(data['result_code']);
					if (errCode === "CALC7" || errCode === "CALC") $rootScope.ga.errors.descisionError(data['result_code']);
					SessionFactory.deleteCurrentSession();
					ErrorFactory.errorPage(data['result_code'], 'en', "Submit failed with response code error", data['result_content']);
					deferred.reject(data.result_code);
				}
			}, function (httpError) {
				SessionFactory.deleteCurrentSession();
				if (httpError.status) {
					ErrorFactory.errorPage("SAE-" + httpError.status, 'en', "Submit failed", "Submit failed with http status code " + httpError.status);
				}
				else {
					ErrorFactory.errorPage("SAU", 'en', "Submit failed", "Submit failed with unexpected error");
				}
			})
			return deferred.promise;
		}

	};

})();
